import { render } from "./App.vue?vue&type=template&id=4e6e1bbe"
const script = {}

import exportComponent from "C:\\Users\\wei-d\\Documents\\TNTAIAGENT\\TNTAIAgent\\tntaiagent\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__